export const ctaClasses = {
    buttons: 'cta-buttons-all',
    cards: 'cta-cards-all',
    homepageBanner: 'cta-hp-banner',
};
